import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, int32_type, list_type, lambda_type, unit_type, class_type, string_type, record_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { LoadState_map, LoadState$2, GlobalDependencies$reflection, LoadState$2$reflection, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { effect } from "../../Components/Hooks/ClickOutside.js";
import { DateTimeExtensions_toIso8601, maskSSN, Locale_get_FromSelectedLanguage, isMobileNumber, normalizePhoneNumber, formatUrl, stackClasses, classNames } from "../../Utils.js";
import { tryHead, isEmpty, cons, filter, map, append, singleton, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { MaterialIcon_render_Z132847CC, IconProps, MaterialIcon_render_Z384F8060, Color, getStatusBall, dotsLoading, Size, getMaterialIconBySize } from "../../ViewUtils.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { isNullOrWhiteSpace, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { customMessage, MessageKind, warning, success, error, info } from "../../Components/Message/Message.js";
import { CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { render as render_1 } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { int32ToString, equals, uncurry, partialApply } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { Modal, Page, Page$reflection } from "./Model.js";
import { Page as Page_1, Page$reflection as Page$reflection_1 } from "../Subscriptions/Model.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { loadContractTypesThunk, loadContractsThunk } from "../../Api/Contract.js";
import { loadInvoiceeCurrentStateThunk, loadInvoiceeTerminationStateThunk, loadInvoiceeBlockThunk, loadInvoiceeThunk } from "../../Api/Invoicee.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { deleteFile, loadFiles, deleteInvoicee as deleteInvoicee_1, loadActivePhoneNumbers as loadActivePhoneNumbers_1 } from "./Api.js";
import { Thunks_loadPendingDirectInvoicesThunk } from "../../Api/DirectInvoice.js";
import { Thunks_loadInvoiceeFeesThunk } from "../../Api/Fee.js";
import { toString, equals as equals_1 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { InvoiceePaymentStateModule_toString, TerminationStateModule_toString, InvoiceeTypeModule_toOrgHeader, InvoiceeStateModule_toTranslation } from "../../DomainTypes.js";
import { PauseTerminationProcessModalProps, renderPauseTerminationProcessModal } from "../PauseTerminationProcess/View.js";
import { pauseTerminationProcess } from "../PauseTerminationProcess/Api.js";
import { SendSMSModalProps, renderSendSMSModal } from "../SendSMS/View.js";
import { sendSms } from "../SendSMS/Api.js";
import { unEscape } from "../../Utilities/String.js";
import { InvoiceeFileType, BlockType } from "./Common.js";
import { empty, singleton as singleton_2, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { FSharpSet__Contains } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { SubscriptionsProps } from "../Subscriptions/View.js";
import { InvoicesProps, renderInvoices } from "../Invoices/View.js";
import { value as value_9 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { loadInvoices, loadPaymentOptions, loadUpcomingInvoices, loadReminderFees } from "../Invoices/Api.js";
import { deleteAgreement, deleteConnection, connectAgreement, unblockMortgage, blockMortgage, approveContract, confirmAgreementFn, loadAgreements, uploadInvoiceeFile } from "../Agreements/Api.js";
import { NotesAndDocumentsProps } from "./Notes.js";
import { Result_Map } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { today } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { loadAllContractTypes } from "../ContractType/Api.js";
import { AgreementsProps } from "../Agreements/View.js";
import { CustomerFeesProps } from "../CustomerFees/View.js";
import { InvoiceeHistoryProps } from "../InvoiceeHistory/View.js";
import { WholesaleRGUProps, renderWholesaleRGU } from "../WholesaleRGU/View.js";
import { NumberDirectoryProps, render as render_2 } from "../NumberDirectory/View.js";
import { AttributesProps } from "../InvoiceeAttributes/View.js";
import { InvoiceeDetailsProps } from "../InvoiceeDetails/View.js";
import "../../../src/Containers/Invoicee/View.scss";


export class TripleDotButtonState extends Record {
    constructor(ShowMenu) {
        super();
        this.ShowMenu = ShowMenu;
    }
}

export function TripleDotButtonState$reflection() {
    return record_type("Containers.Invoicee.View.TripleDotButtonState", [], TripleDotButtonState, () => [["ShowMenu", bool_type]]);
}

export class TripleDotButtonProps extends Record {
    constructor(S5Href, ShowSendSmsButton, SendSmsOnClick, ShowHoldOrUnholdTerminationProcessButton, HoldOrUnholdTerminationProcessOnClick, DeleteInvoiceeOnClick) {
        super();
        this.S5Href = S5Href;
        this.ShowSendSmsButton = ShowSendSmsButton;
        this.SendSmsOnClick = SendSmsOnClick;
        this.ShowHoldOrUnholdTerminationProcessButton = ShowHoldOrUnholdTerminationProcessButton;
        this.HoldOrUnholdTerminationProcessOnClick = HoldOrUnholdTerminationProcessOnClick;
        this.DeleteInvoiceeOnClick = DeleteInvoiceeOnClick;
    }
}

export function TripleDotButtonProps$reflection() {
    return record_type("Containers.Invoicee.View.TripleDotButtonProps", [], TripleDotButtonProps, () => [["S5Href", string_type], ["ShowSendSmsButton", bool_type], ["SendSmsOnClick", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)], ["ShowHoldOrUnholdTerminationProcessButton", bool_type], ["HoldOrUnholdTerminationProcessOnClick", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)], ["DeleteInvoiceeOnClick", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)]]);
}

const renderTripleDotButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children_2, children_9, children_14, children_18, children_26, children_24, children_22, children_20;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const state_1 = react.useState(new TripleDotButtonState(false));
    const wrapperRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(wrapperRef, () => {
        let inputRecord;
        state_1[1]((inputRecord = (state_1[0]), new TripleDotButtonState(false)));
    }, void 0))();
        return () => disp.Dispose();
    });
    const menuClasses = classNames(ofArray([["dot-menu__container", true], ["d-none", !(state_1[0]).ShowMenu]]));
    let s5LinkListItem;
    const children_6 = [(children_4 = [react.createElement("span", {
        className: "content__icon",
    }), (children_2 = [getTranslation("CustomerContract.Invoicee.OpenS5")], react.createElement("span", {
        ["data-translation"]: "CustomerContract.Invoicee.OpenS5",
    }, ...children_2))], react.createElement("a", {
        id: "invoicee-go-to-s5",
        className: "d-flex list-item__content",
        href: props.S5Href,
        target: "_s5",
    }, ...children_4))];
    s5LinkListItem = react.createElement("li", {
        className: "list-item",
    }, ...children_6);
    let sendSmsListItem;
    if (props.ShowSendSmsButton) {
        const children_11 = [(children_9 = [getTranslation("CustomerContract.Invoicee.SendSMS")], react.createElement("span", {
            className: "list-item__content",
            ["data-translation"]: "CustomerContract.Invoicee.SendSMS",
        }, ...children_9))];
        sendSmsListItem = react.createElement("li", {
            id: "invoicee-send-sms",
            className: "list-item",
            onClick: props.SendSmsOnClick,
        }, ...children_11);
    }
    else {
        sendSmsListItem = react.createElement(react.Fragment, {});
    }
    let terminationProcessHoldOrUnhold;
    if (props.ShowHoldOrUnholdTerminationProcessButton) {
        const children_16 = [(children_14 = [getTranslation("CustomerContract.Invoicee.TerminationState.Paus")], react.createElement("span", {
            className: "list-item__content",
            ["data-translation"]: "CustomerContract.Invoicee.TerminationState.Paus",
        }, ...children_14))];
        terminationProcessHoldOrUnhold = react.createElement("li", {
            id: "invoicee-send-sms",
            className: "list-item",
            onClick: props.HoldOrUnholdTerminationProcessOnClick,
        }, ...children_16);
    }
    else {
        terminationProcessHoldOrUnhold = react.createElement(react.Fragment, {});
    }
    const children_28 = [(children_18 = [getMaterialIconBySize("more_vert", new Size(3))], react.createElement("div", {
        className: "dot-menu__icon",
        onClick: (_arg) => {
            state_1[1](new TripleDotButtonState(!(state_1[0]).ShowMenu));
        },
    }, ...children_18)), (children_26 = [(children_24 = [sendSmsListItem, s5LinkListItem, terminationProcessHoldOrUnhold, (children_22 = [(children_20 = [getTranslation("CustomerContract.Invoicee.DeleteInvoicee")], react.createElement("span", {
        className: "list-item__content",
        ["data-translation"]: "CustomerContract.Invoicee.DeleteInvoicee",
    }, ...children_20))], react.createElement("li", {
        id: "invoicee-delete",
        className: "list-item",
        onClick: props.DeleteInvoiceeOnClick,
    }, ...children_22))], react.createElement("ul", {
        className: "dot-menu__list",
        onClick: (_arg_1) => {
            state_1[1](new TripleDotButtonState(!(state_1[0]).ShowMenu));
        },
    }, ...children_24))], react.createElement("div", {
        className: menuClasses,
    }, ...children_26))];
    return react.createElement("div", {
        id: "invoicee-triple-dot-menu",
        className: "invoicee__dot-menu",
        ref: wrapperRef,
    }, ...children_28);
}, "TripleDotButton", Helpers_equalsButFunctions, void 0, "renderTripleDotButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoicee\\View.fs", 111);

export class DeleteInvoiceModalProps extends Record {
    constructor(IsAdmin, GetTranslation, OnClose, OnAccept, OnCloseAfterDelete, Status) {
        super();
        this.IsAdmin = IsAdmin;
        this.GetTranslation = GetTranslation;
        this.OnClose = OnClose;
        this.OnAccept = OnAccept;
        this.OnCloseAfterDelete = OnCloseAfterDelete;
        this.Status = Status;
    }
}

export function DeleteInvoiceModalProps$reflection() {
    return record_type("Containers.Invoicee.View.DeleteInvoiceModalProps", [], DeleteInvoiceModalProps, () => [["IsAdmin", bool_type], ["GetTranslation", lambda_type(string_type, string_type)], ["OnClose", lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type)], ["OnAccept", lambda_type(bool_type, lambda_type(class_type("Browser.Types.Event", void 0, Event), unit_type))], ["OnCloseAfterDelete", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)], ["Status", LoadState$2$reflection(unit_type, string_type)]]);
}

export const renderDeleteInvoiceeModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let arg, inputRecord, children_5;
    const shouldForceDeleteState = react.useState(false);
    let contentHtml;
    let notInvoicedTextHtml;
    const children = [(arg = props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.NotInvoiced"), toText(printf("(%s)"))(arg))];
    notInvoicedTextHtml = react.createElement("p", {
        className: "mt-2",
    }, ...children);
    let isForceCheckBoxHtml;
    if (props.IsAdmin) {
        const children_3 = [info(props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.AttemptForceDeleteInfo").split("")), inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord.Disabled, props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.AttemptForceDelete"), (e) => {
            const arg_1 = Browser_Types_Event__Event_get_Checked(e);
            shouldForceDeleteState[1](arg_1);
        }, shouldForceDeleteState[0], "delete-invoice-modal-admin-force-delete", inputRecord.HTMLProps)))];
        isForceCheckBoxHtml = react.createElement("div", {
            className: "invoicee-overview__delete-box",
        }, ...children_3);
    }
    else {
        isForceCheckBoxHtml = react.createElement(react.Fragment, {});
    }
    const matchValue_1 = props.Status;
    switch (matchValue_1.tag) {
        case 1: {
            contentHtml = dotsLoading;
            break;
        }
        case 3: {
            const children_8 = [error(matchValue_1.fields[0].split("")), notInvoicedTextHtml];
            contentHtml = react.createElement(react.Fragment, {}, ...children_8);
            break;
        }
        case 2: {
            const props_10 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-center"])))];
            const children_9 = [success(props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.InvoiceeDeleted").split(""))];
            contentHtml = react.createElement("div", keyValueList(props_10, 1), ...children_9);
            break;
        }
        default: {
            const children_7 = [(children_5 = [props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.AreYouSure")], react.createElement("p", {
                className: "font-weight-bold",
            }, ...children_5)), notInvoicedTextHtml, isForceCheckBoxHtml];
            contentHtml = react.createElement(react.Fragment, {}, ...children_7);
        }
    }
    if (props.Status.tag === 2) {
        return renderAsModal(props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee"), contentHtml, new MessageType(0), props.GetTranslation("Common.Ok"), props.OnCloseAfterDelete);
    }
    else {
        return render_1(true, new ModalSize(1), props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee"), react.createElement("div", {
            id: "delete-invoicee-modal",
            className: "mt-2 mb-2",
        }, contentHtml), props.GetTranslation("Common.Cancel"), props.GetTranslation("CustomerContract.Invoicee.DeleteInvoicee.Delete"), props.OnClose, partialApply(1, props.OnAccept, [props.IsAdmin && (shouldForceDeleteState[0])]));
    }
}, "DeleteInvoiceeModal", uncurry(2, void 0), void 0, "renderDeleteInvoiceeModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoicee\\View.fs", 189);

export const LazyPages_DetailsPage = (() => {
    const elemType = react.lazy(() => import("../InvoiceeDetails/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_SubscriptionsPage = (() => {
    const elemType = react.lazy(() => import("../Subscriptions/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_NotesPage = (() => {
    const elemType = react.lazy(() => import("./Notes.js").then((m) => m.renderNotesAndDocuments).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_AgreementsPage = (() => {
    const elemType = react.lazy(() => import("../Agreements/View.js").then((m) => m.renderAgreements).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_CustomerFeesPage = (() => {
    const elemType = react.lazy(() => import("../CustomerFees/View.js").then((m) => m.renderCustomerFees).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_HistoryPage = (() => {
    const elemType = react.lazy(() => import("../InvoiceeHistory/View.js").then((m) => m.renderInvoiceeHistory).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_WholesaleRGU = (() => {
    const elemType = react.lazy(() => import("../WholesaleRGU/View.js").then((m) => m.renderWholesaleRGU).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

export const LazyPages_AttributesPage = (() => {
    const elemType = react.lazy(() => import("../InvoiceeAttributes/View.js").then((m) => m.renderAttributes).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

class HorizontalMenuProps extends Record {
    constructor(CurrentUrlSegments, BaseSegments, CurrentSubscriptionContractNr, CurrentInvoiceePage, InvoiceeNr, HasCustomerFees, ClientNr, CurrentSubscriptionPage, MortgageEnabled, DocumentSigningEnabled, MortgageRead, AllowSendSms, IsAdminUser, UsesNumberDirectory, OpenSendSmsModalFn, OpenDeleteInvoiceeModalFn, OpenHoldOrUnholdTerminationProcessModalFn, EnableTerminationProcess, ShowInvoiceeAttributes) {
        super();
        this.CurrentUrlSegments = CurrentUrlSegments;
        this.BaseSegments = BaseSegments;
        this.CurrentSubscriptionContractNr = CurrentSubscriptionContractNr;
        this.CurrentInvoiceePage = CurrentInvoiceePage;
        this.InvoiceeNr = InvoiceeNr;
        this.HasCustomerFees = HasCustomerFees;
        this.ClientNr = (ClientNr | 0);
        this.CurrentSubscriptionPage = CurrentSubscriptionPage;
        this.MortgageEnabled = MortgageEnabled;
        this.DocumentSigningEnabled = DocumentSigningEnabled;
        this.MortgageRead = MortgageRead;
        this.AllowSendSms = AllowSendSms;
        this.IsAdminUser = IsAdminUser;
        this.UsesNumberDirectory = UsesNumberDirectory;
        this.OpenSendSmsModalFn = OpenSendSmsModalFn;
        this.OpenDeleteInvoiceeModalFn = OpenDeleteInvoiceeModalFn;
        this.OpenHoldOrUnholdTerminationProcessModalFn = OpenHoldOrUnholdTerminationProcessModalFn;
        this.EnableTerminationProcess = EnableTerminationProcess;
        this.ShowInvoiceeAttributes = ShowInvoiceeAttributes;
    }
}

function HorizontalMenuProps$reflection() {
    return record_type("Containers.Invoicee.View.HorizontalMenuProps", [], HorizontalMenuProps, () => [["CurrentUrlSegments", list_type(string_type)], ["BaseSegments", list_type(string_type)], ["CurrentSubscriptionContractNr", option_type(int32_type)], ["CurrentInvoiceePage", Page$reflection()], ["InvoiceeNr", class_type("System.Int64")], ["HasCustomerFees", LoadState$2$reflection(bool_type, string_type)], ["ClientNr", int32_type], ["CurrentSubscriptionPage", Page$reflection_1()], ["MortgageEnabled", bool_type], ["DocumentSigningEnabled", bool_type], ["MortgageRead", bool_type], ["AllowSendSms", bool_type], ["IsAdminUser", bool_type], ["UsesNumberDirectory", bool_type], ["OpenSendSmsModalFn", lambda_type(unit_type, unit_type)], ["OpenDeleteInvoiceeModalFn", lambda_type(unit_type, unit_type)], ["OpenHoldOrUnholdTerminationProcessModalFn", lambda_type(unit_type, unit_type)], ["EnableTerminationProcess", bool_type], ["ShowInvoiceeAttributes", bool_type]]);
}

const renderHorizontalMenu = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_1, children, props_5, children_4, props_9, children_8, props_13, children_12, props_18, children_17, props_23, children_22, arg_8, arg_7, props_27, children_26, props_32, props_37, children_36, props_42, children_41;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const getSubnavClasses = (currentPage, thisPage) => {
        const baseClass = "invoicee-overview__subnav";
        if (equals(currentPage, thisPage)) {
            return baseClass + " invoicee-overview__subnav--active";
        }
        else {
            return baseClass;
        }
    };
    let detailsLinkHtml;
    const detailsUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Details")), 1);
    const children_2 = [(props_1 = [new HTMLAttr(99, "invoicee-view-details"), ["data-translation", "CustomerContract.Invoicee.CustomerData"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(0, props.InvoiceeNr)))], (children = [getTranslation("CustomerContract.Invoicee.CustomerData")], react.createElement("div", keyValueList(props_1, 1), ...children)))];
    detailsLinkHtml = react.createElement("a", {
        className: "invoicee-overview__navigation",
        href: detailsUrl,
    }, ...children_2);
    let subscriptionsLinkHtml;
    let subscriptionsUrl;
    const matchValue = props.CurrentSubscriptionContractNr;
    if (matchValue == null) {
        subscriptionsUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Subscriptions")), 1);
    }
    else {
        const contractNr = matchValue | 0;
        subscriptionsUrl = RouterModule_encodeParts(append(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Subscriptions")), singleton(int32ToString(contractNr))), 1);
    }
    const children_6 = [(props_5 = [new HTMLAttr(99, "invoicee-view-subscriptions"), ["data-translation", "CustomerContract.Invoicee.ContractList"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(1, props.InvoiceeNr, props.CurrentSubscriptionPage)))], (children_4 = [getTranslation("CustomerContract.Invoicee.ContractList")], react.createElement("div", keyValueList(props_5, 1), ...children_4)))];
    subscriptionsLinkHtml = react.createElement("a", {
        className: "invoicee-overview__navigation",
        href: subscriptionsUrl,
    }, ...children_6);
    let invoicesLinkHtml;
    const invoicesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Invoices")), 1);
    const children_10 = [(props_9 = [new HTMLAttr(99, "invoicee-view-invoices"), ["data-translation", "CustomerContract.Invoicee.Invoices"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(2, props.InvoiceeNr)))], (children_8 = [getTranslation("CustomerContract.Invoicee.Invoices")], react.createElement("div", keyValueList(props_9, 1), ...children_8)))];
    invoicesLinkHtml = react.createElement("a", {
        className: "invoicee-overview__navigation",
        href: invoicesUrl,
    }, ...children_10);
    let agreementsLinkHtml;
    const agreementsUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Agreements")), 1);
    if ((props.MortgageEnabled && props.MortgageRead) ? true : props.DocumentSigningEnabled) {
        const children_14 = [(props_13 = [new HTMLAttr(99, "invoicee-view-agreements"), ["data-translation", "CustomerContract.Invoicee.AgreementsAndMortgage"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(4, props.InvoiceeNr)))], (children_12 = [getTranslation("CustomerContract.Invoicee.AgreementsAndMortgage")], react.createElement("div", keyValueList(props_13, 1), ...children_12)))];
        agreementsLinkHtml = react.createElement("a", {
            className: "invoicee-overview__navigation",
            href: agreementsUrl,
        }, ...children_14);
    }
    else {
        agreementsLinkHtml = react.createElement(react.Fragment, {});
    }
    let customerFeesLinkHtml;
    const customerFeesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("CustomerFees")), 1);
    const matchValue_1 = props.HasCustomerFees;
    let pattern_matching_result;
    if (matchValue_1.tag === 2) {
        if (matchValue_1.fields[0]) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const children_19 = [(props_18 = [new HTMLAttr(99, "invoicee-view-fees"), ["data-translation", "CustomerContract.Invoicee.CustomerFees"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(5, props.InvoiceeNr)))], (children_17 = [getTranslation("CustomerContract.Invoicee.CustomerFees")], react.createElement("div", keyValueList(props_18, 1), ...children_17)))];
            customerFeesLinkHtml = react.createElement("a", {
                className: "invoicee-overview__navigation",
                href: customerFeesUrl,
            }, ...children_19);
            break;
        }
        case 1: {
            customerFeesLinkHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    let notesLinkHtml;
    const notesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Notes")), 1);
    const children_24 = [(props_23 = [new HTMLAttr(99, "invoicee-view-notes"), ["data-translation", "CustomerContract.Invoicee.Notes"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(3, props.InvoiceeNr)))], (children_22 = [(arg_8 = getTranslation("Common.Documents"), (arg_7 = getTranslation("CustomerContract.Invoicee.Notes"), toText(printf("%s \u0026 %s"))(arg_7)(arg_8)))], react.createElement("div", keyValueList(props_23, 1), ...children_22)))];
    notesLinkHtml = react.createElement("a", {
        className: "invoicee-overview__navigation",
        href: notesUrl,
    }, ...children_24);
    let invoiceeHistoryLinkHtml;
    const invoiceeHistoryUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("History")), 1);
    const children_28 = [(props_27 = [new HTMLAttr(99, "invoicee-view-history"), ["data-translation", "CustomerContract.Invoicee.History"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(6, props.InvoiceeNr)))], (children_26 = [getTranslation("CustomerContract.Invoicee.History")], react.createElement("div", keyValueList(props_27, 1), ...children_26)))];
    invoiceeHistoryLinkHtml = react.createElement("a", {
        className: "invoicee-overview__navigation",
        href: invoiceeHistoryUrl,
    }, ...children_28);
    let wholesaleRGULinkHtml;
    const matchValue_2 = props.IsAdminUser && (((props.ClientNr === 1137) ? true : (props.ClientNr === 1173)) ? true : (props.ClientNr === 1174));
    if (matchValue_2) {
        const props_34 = [new HTMLAttr(65, "invoicee-overview__navigation"), new HTMLAttr(94, RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("WholesaleRGU")), 1))];
        const children_33 = [(props_32 = [new HTMLAttr(99, "invoicee-view-wholesale-rgu"), new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(7, props.InvoiceeNr)))], react.createElement("div", keyValueList(props_32, 1), "WholesaleRGU"))];
        wholesaleRGULinkHtml = react.createElement("a", keyValueList(props_34, 1), ...children_33);
    }
    else {
        wholesaleRGULinkHtml = react.createElement(react.Fragment, {});
    }
    let numberDirectoryLinkHtml;
    if (props.UsesNumberDirectory) {
        const numberDirectoryUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("NumberDirectory")), 1);
        const children_38 = [(props_37 = [new HTMLAttr(99, "invoicee-view-number-directory"), ["data-translation", "CustomerContract.Invoicee.NumberDirectory"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(8, props.InvoiceeNr)))], (children_36 = [getTranslation("CustomerContract.Invoicee.NumberDirectory")], react.createElement("div", keyValueList(props_37, 1), ...children_36)))];
        numberDirectoryLinkHtml = react.createElement("a", {
            className: "invoicee-overview__navigation",
            href: numberDirectoryUrl,
        }, ...children_38);
    }
    else {
        numberDirectoryLinkHtml = react.createElement(react.Fragment, {});
    }
    let attributesLinkHtml;
    if (props.ShowInvoiceeAttributes) {
        const attributesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton("Attributes")), 1);
        const children_43 = [(props_42 = [new HTMLAttr(99, "invoicee-view-attributes"), ["data-translation", "Common.Attribute"], new HTMLAttr(65, getSubnavClasses(props.CurrentInvoiceePage, new Page(9, props.InvoiceeNr)))], (children_41 = [getTranslation("Common.Attribute")], react.createElement("div", keyValueList(props_42, 1), ...children_41)))];
        attributesLinkHtml = react.createElement("a", {
            className: "invoicee-overview__navigation",
            href: attributesUrl,
        }, ...children_43);
    }
    else {
        attributesLinkHtml = react.createElement(react.Fragment, {});
    }
    const tripleDotButtonHtml = renderTripleDotButton(new TripleDotButtonProps(toText(printf("https://s5.svea.com/#views/client/%i/customer/%i"))(props.ClientNr)(props.InvoiceeNr), props.AllowSendSms, (_arg) => {
        props.OpenSendSmsModalFn();
    }, props.EnableTerminationProcess, (_arg_1) => {
        props.OpenHoldOrUnholdTerminationProcessModalFn();
    }, (_arg_2) => {
        props.OpenDeleteInvoiceeModalFn();
    }));
    const children_47 = [react.createElement("div", {
        className: "d-flex align-items-center",
    }, subscriptionsLinkHtml, invoicesLinkHtml, detailsLinkHtml, attributesLinkHtml, agreementsLinkHtml, customerFeesLinkHtml, notesLinkHtml, invoiceeHistoryLinkHtml, wholesaleRGULinkHtml, numberDirectoryLinkHtml), tripleDotButtonHtml];
    return react.createElement("div", {
        className: "invoicee-overview__border d-flex mt-3 mb-4 justify-content-between",
    }, ...children_47);
}, "HorizontalMenu", Helpers_equalsButFunctions, void 0, "renderHorizontalMenu", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoicee\\View.fs", 445);

export class InvoiceeProps extends Record {
    constructor(GlobalDependencies, CurrentPage) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentPage = CurrentPage;
    }
}

export function InvoiceeProps$reflection() {
    return record_type("Containers.Invoicee.View.InvoiceeProps", [], InvoiceeProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentPage", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue_4, props_17, children_16, props_25, children_24, text, children_30, children_28, latestInvoiceeBlock_1, latestInvoiceeBlock_2, matchValue_13;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const invoiceeDetailsLoadState = useSelector((state_1) => state_1.Invoicee.InvoiceeDetails);
    const contractTypesLoadState = useSelector((state_2) => state_2.Contract.ContractTypes);
    const contractsLoadState = useSelector((state_3) => state_3.Contract.Contracts);
    const pendingDirectInvoiceLoadState = useSelector((state_4) => state_4.DirectInvoice.PendingDirectInvoices);
    const invoiceeFeesLoadState = useSelector((state_5) => state_5.Invoicee.InvoiceeFees);
    const invoiceeBlockState = useSelector((state_6) => state_6.Invoicee.InvoiceeBlock);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reduxDispatch = useDispatch();
    const loadContracts = (invoiceeNr) => {
        reduxDispatch(loadContractsThunk(props.GlobalDependencies.ClientNr, invoiceeNr));
    };
    const loadInvoiceeDetails = (invoiceeNr_1) => {
        reduxDispatch(loadInvoiceeThunk(props.GlobalDependencies.ClientNr, invoiceeNr_1));
    };
    const openModalState = react.useState(new Modal(5));
    const deleteInvoiceeState = react.useState(new LoadState$2(0));
    const errorMessageState = react.useState(void 0);
    const activePhoneNumbersState = react.useState(new LoadState$2(0));
    const loadActivePhoneNumbers = (contractNrs) => {
        activePhoneNumbersState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(loadActivePhoneNumbers_1(props.GlobalDependencies.ClientNr, {
            ContractNrs: contractNrs,
        }), (_arg_1) => {
            let details, realValue, arg_6;
            const result_1 = _arg_1;
            let arg_7;
            if (result_1.tag === 1) {
                arg_7 = (new LoadState$2(3, result_1.fields[0]));
            }
            else {
                const alpha3CountryCode = props.GlobalDependencies.CountryCode;
                const normalizedPhoneNumbers = map((number_1) => {
                    let arg_4, arg_3;
                    const normalizedNumber = normalizePhoneNumber(number_1.NumberFrom, alpha3CountryCode);
                    return [normalizedNumber, (arg_4 = int32ToString(number_1.ContractNr), (arg_3 = getTranslation("CustomerContract.Invoicee.Contract"), toText(printf("%s (%s %s)"))(normalizedNumber)(arg_3)(arg_4)))];
                }, filter((number) => {
                    if (number.IsActive) {
                        return number.NumberFrom === number.NumberTo;
                    }
                    else {
                        return false;
                    }
                }, result_1.fields[0].ActiveNumbers));
                arg_7 = (new LoadState$2(2, filter((tupledArg) => isMobileNumber(alpha3CountryCode.ThreeLetter, tupledArg[0]), (invoiceeDetailsLoadState.tag === 2) ? ((invoiceeDetailsLoadState.fields[0] != null) ? ((details = invoiceeDetailsLoadState.fields[0], (!isNullOrWhiteSpace(details.ContactPhoneNumber)) ? ((realValue = normalizePhoneNumber(details.ContactPhoneNumber, alpha3CountryCode), cons([realValue, (arg_6 = getTranslation("CustomerContract.Invoicee.ContactNumber"), toText(printf("%s (%s)"))(realValue)(arg_6))], normalizedPhoneNumbers))) : normalizedPhoneNumbers)) : normalizedPhoneNumbers) : normalizedPhoneNumbers)));
            }
            activePhoneNumbersState[1](arg_7);
            return singleton_1.Zero();
        })));
    };
    const loadDependencies = (invoiceeNr_8) => {
        loadInvoiceeDetails(invoiceeNr_8);
        loadContracts(invoiceeNr_8);
        reduxDispatch(loadInvoiceeBlockThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
        if (props.GlobalDependencies.ClientConfig.EnableTerminationProcess) {
            reduxDispatch(loadInvoiceeTerminationStateThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
        }
        switch (pendingDirectInvoiceLoadState.tag) {
            case 3: {
                reduxDispatch(Thunks_loadPendingDirectInvoicesThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
                break;
            }
            case 1:
            case 2: {
                break;
            }
            default: {
                reduxDispatch(Thunks_loadPendingDirectInvoicesThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
            }
        }
        switch (invoiceeFeesLoadState.tag) {
            case 3: {
                reduxDispatch(Thunks_loadInvoiceeFeesThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
                break;
            }
            case 1:
            case 2: {
                break;
            }
            default: {
                reduxDispatch(Thunks_loadInvoiceeFeesThunk(props.GlobalDependencies.ClientNr, invoiceeNr_8));
            }
        }
    };
    react.useEffect(() => {
        const matchValue = props.CurrentPage;
        let pattern_matching_result, invoiceeNr_9;
        switch (matchValue.tag) {
            case 1: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 2: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 3: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 4: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 5: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 6: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 7: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 9: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 8: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
                break;
            }
            case 10:
            case 11: {
                pattern_matching_result = 1;
                break;
            }
            default: {
                pattern_matching_result = 0;
                invoiceeNr_9 = matchValue.fields[0];
            }
        }
        switch (pattern_matching_result) {
            case 0: {
                let pattern_matching_result_1, invoiceeDetails;
                if (invoiceeDetailsLoadState.tag === 0) {
                    pattern_matching_result_1 = 0;
                }
                else if (invoiceeDetailsLoadState.tag === 3) {
                    pattern_matching_result_1 = 0;
                }
                else if (invoiceeDetailsLoadState.tag === 2) {
                    if (invoiceeDetailsLoadState.fields[0] != null) {
                        pattern_matching_result_1 = 1;
                        invoiceeDetails = invoiceeDetailsLoadState.fields[0];
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                }
                else {
                    pattern_matching_result_1 = 2;
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        loadDependencies(invoiceeNr_9);
                        break;
                    }
                    case 1: {
                        if (!equals_1(invoiceeDetails.InvoiceeNr, invoiceeNr_9)) {
                            loadDependencies(invoiceeNr_9);
                        }
                        break;
                    }
                    case 2: {
                        break;
                    }
                }
                break;
            }
            case 1: {
                break;
            }
        }
    }, [props.CurrentPage]);
    react.useEffect(() => {
        reduxDispatch(loadContractTypesThunk(props.GlobalDependencies.ClientNr, true));
        const matchValue_2 = props.CurrentPage;
        let pattern_matching_result_2, invoiceeNr_10;
        switch (matchValue_2.tag) {
            case 1: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 2: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 3: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 4: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 5: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 6: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 7: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 8: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 9: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
                break;
            }
            case 10:
            case 11: {
                pattern_matching_result_2 = 1;
                break;
            }
            default: {
                pattern_matching_result_2 = 0;
                invoiceeNr_10 = matchValue_2.fields[0];
            }
        }
        switch (pattern_matching_result_2) {
            case 0: {
                loadDependencies(invoiceeNr_10);
                break;
            }
            case 1: {
                break;
            }
        }
    }, [props.GlobalDependencies]);
    const matchValue_3 = props.CurrentPage;
    switch (matchValue_3.tag) {
        case 10: {
            const children = [warning(getTranslation("CustomerContract.Invoicee.MissingInvoiceeNr").split(""))];
            return react.createElement("div", {}, ...children);
        }
        case 11: {
            const children_2 = [warning("404 - Not Found".split(""))];
            return react.createElement("div", {}, ...children_2);
        }
        default: {
            const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
            if (invoiceeDetailsLoadState.tag === 3) {
                const children_4 = [error(invoiceeDetailsLoadState.fields[0].split(""))];
                return react.createElement("div", {}, ...children_4);
            }
            else if (invoiceeDetailsLoadState.tag === 0) {
                const children_6 = [info((getTranslation("CustomerContract.Invoicee.WaitingToLoad") + "...").split(""))];
                return react.createElement("div", {}, ...children_6);
            }
            else if (invoiceeDetailsLoadState.tag === 2) {
                if (invoiceeDetailsLoadState.fields[0] != null) {
                    const details_1 = invoiceeDetailsLoadState.fields[0];
                    const statusBallHtml = getStatusBall((matchValue_4 = details_1.CurrentState, (matchValue_4.tag === 1) ? (new Color(0)) : ((matchValue_4.tag === 2) ? (new Color(2)) : ((matchValue_4.tag === 5) ? (new Color(2)) : ((matchValue_4.tag === 4) ? (new Color(2)) : ((matchValue_4.tag === 3) ? (new Color(1)) : (new Color(0))))))), InvoiceeStateModule_toTranslation(getTranslation, details_1.CurrentState));
                    const ssnOrOrgTitle = InvoiceeTypeModule_toOrgHeader(getTranslation, details_1.InvoiceType);
                    const orgNr = maskSSN(details_1.OrganizationNr, props.GlobalDependencies.CountryCode);
                    let pauseTerminationProcessModalHtml;
                    const matchValue_5 = [equals(openModalState[0], new Modal(4)), invoiceeDetailsLoadState];
                    let pattern_matching_result_3, invoiceeDetails_1;
                    if (matchValue_5[0]) {
                        if (matchValue_5[1].tag === 0) {
                            pattern_matching_result_3 = 0;
                        }
                        else if (matchValue_5[1].tag === 1) {
                            pattern_matching_result_3 = 1;
                        }
                        else if (matchValue_5[1].tag === 2) {
                            if (matchValue_5[1].fields[0] != null) {
                                pattern_matching_result_3 = 2;
                                invoiceeDetails_1 = matchValue_5[1].fields[0];
                            }
                            else {
                                pattern_matching_result_3 = 3;
                            }
                        }
                        else {
                            pattern_matching_result_3 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_3 = 3;
                    }
                    switch (pattern_matching_result_3) {
                        case 0: {
                            pauseTerminationProcessModalHtml = info("InvoiceeDetails not loaded".split(""));
                            break;
                        }
                        case 1: {
                            pauseTerminationProcessModalHtml = dotsLoading;
                            break;
                        }
                        case 2: {
                            pauseTerminationProcessModalHtml = renderPauseTerminationProcessModal(new PauseTerminationProcessModalProps(() => {
                                openModalState[1](new Modal(5));
                            }, (pause) => pauseTerminationProcess(props.GlobalDependencies.ClientNr, invoiceeDetails_1.InvoiceeNr, pause), getTranslation("CustomerContract.Invoicee.TerminationState.Paus")));
                            break;
                        }
                        case 3: {
                            pauseTerminationProcessModalHtml = react.createElement(react.Fragment, {});
                            break;
                        }
                    }
                    let deleteInvoiceeModalHtml;
                    const matchValue_6 = equals(openModalState[0], new Modal(3));
                    deleteInvoiceeModalHtml = (matchValue_6 ? renderDeleteInvoiceeModal(new DeleteInvoiceModalProps(props.GlobalDependencies.IsAdminUser, getTranslation, (_arg_3) => {
                        openModalState[1](new Modal(5));
                    }, (force_1, _arg_4) => {
                        deleteInvoiceeState[1](new LoadState$2(1));
                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(deleteInvoicee_1(props.GlobalDependencies.ClientNr, details_1.InvoiceeNr, force_1), (_arg) => {
                            const result = _arg;
                            let arg;
                            if (result.tag === 1) {
                                const msg = result.fields[0];
                                errorMessageState[1](msg);
                                arg = (new LoadState$2(3, msg));
                            }
                            else {
                                arg = (new LoadState$2(2, void 0));
                            }
                            deleteInvoiceeState[1](arg);
                            return singleton_1.Zero();
                        })));
                    }, (_arg_5) => {
                        openModalState[1](new Modal(5));
                        loadInvoiceeDetails(details_1.InvoiceeNr);
                    }, deleteInvoiceeState[0])) : react.createElement(react.Fragment, {}));
                    let sendSMSModalHtml;
                    const matchValue_7 = [equals(openModalState[0], new Modal(1)), invoiceeDetailsLoadState];
                    let pattern_matching_result_4, invoiceeDetails_2;
                    if (matchValue_7[0]) {
                        if (matchValue_7[1].tag === 0) {
                            pattern_matching_result_4 = 0;
                        }
                        else if (matchValue_7[1].tag === 1) {
                            pattern_matching_result_4 = 1;
                        }
                        else if (matchValue_7[1].tag === 2) {
                            if (matchValue_7[1].fields[0] != null) {
                                pattern_matching_result_4 = 2;
                                invoiceeDetails_2 = matchValue_7[1].fields[0];
                            }
                            else {
                                pattern_matching_result_4 = 3;
                            }
                        }
                        else {
                            pattern_matching_result_4 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_4 = 3;
                    }
                    switch (pattern_matching_result_4) {
                        case 0: {
                            sendSMSModalHtml = info("InvoiceeDetails not loaded".split(""));
                            break;
                        }
                        case 1: {
                            sendSMSModalHtml = dotsLoading;
                            break;
                        }
                        case 2: {
                            sendSMSModalHtml = renderSendSMSModal(new SendSMSModalProps(activePhoneNumbersState[0], () => {
                                openModalState[1](new Modal(5));
                            }, "", (data) => sendSms(props.GlobalDependencies.ClientNr, invoiceeDetails_2.InvoiceeNr, data), getTranslation("CustomerContract.Invoicee.SendSMS")));
                            break;
                        }
                        case 3: {
                            sendSMSModalHtml = react.createElement(react.Fragment, {});
                            break;
                        }
                    }
                    let terminationProcessStateHtml;
                    const matchValue_8 = details_1.TerminationState;
                    if (matchValue_8.tag === 0) {
                        terminationProcessStateHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const terminationState = matchValue_8;
                        const patternInput = (terminationState.tag === 5) ? ["warning", new MessageKind(1), getTranslation("CustomerContract.Invoicee.TerminationState.Warning")] : ((terminationState.tag === 4) ? ["hourglass_top", new MessageKind(1), getTranslation("CustomerContract.Invoicee.TerminationState.Terminating")] : ((terminationState.tag === 3) ? ["check_circle", new MessageKind(2), getTranslation("CustomerContract.Invoicee.TerminationState.Terminated")] : ((terminationState.tag === 2) ? ["pause_circle", new MessageKind(0), getTranslation("CustomerContract.Invoicee.TerminationState.Hold")] : ((terminationState.tag === 6) ? ["info", new MessageKind(0), terminationState.fields[0]] : ((terminationState.tag === 0) ? ["info", new MessageKind(0), ""] : ["error", new MessageKind(1), getTranslation("CustomerContract.Invoicee.TerminationState.Alert")])))));
                        const msg_3 = patternInput[2];
                        const terminationStateText = TerminationStateModule_toString(terminationState);
                        terminationProcessStateHtml = customMessage((props_17 = [new HTMLAttr(99, "invoicee-termination-state"), new HTMLAttr(65, "cursor-help d-flex"), new HTMLAttr(158, `Termination State: ${terminationStateText}`)], (children_16 = [MaterialIcon_render_Z384F8060(patternInput[0], msg_3), react.createElement("span", {
                            className: "ml-2",
                        }, msg_3)], react.createElement("div", keyValueList(props_17, 1), ...children_16))), patternInput[1]);
                    }
                    let paymentWarningMsgHtml;
                    if (details_1.PaymentState.tag === 5) {
                        paymentWarningMsgHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        let msg_4;
                        const matchValue_10 = details_1.PaymentState;
                        switch (matchValue_10.tag) {
                            case 1: {
                                msg_4 = getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.Reminder1");
                                break;
                            }
                            case 2: {
                                msg_4 = getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.DebtCollection1");
                                break;
                            }
                            case 3: {
                                msg_4 = getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.DebtCollection2");
                                break;
                            }
                            case 4: {
                                msg_4 = getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.DebtCollection2Plus");
                                break;
                            }
                            case 5: {
                                msg_4 = "";
                                break;
                            }
                            case 6: {
                                msg_4 = matchValue_10.fields[0];
                                break;
                            }
                            default: {
                                msg_4 = getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.StoppedForReminder");
                            }
                        }
                        let questionMarkHtml;
                        const matchValue_11 = details_1.PaymentState;
                        switch (matchValue_11.tag) {
                            case 2:
                            case 3:
                            case 4: {
                                const children_19 = [MaterialIcon_render_Z384F8060("info", getTranslation("CustomerContract.Invoicee.DebtCollectionWarning.DebtCollectionExplanation"))];
                                questionMarkHtml = react.createElement("span", {
                                    className: "ml-2",
                                }, ...children_19);
                                break;
                            }
                            default: {
                                questionMarkHtml = react.createElement(react.Fragment, {});
                            }
                        }
                        paymentWarningMsgHtml = customMessage((props_25 = [new HTMLAttr(99, "invoicee-payment-warning"), new HTMLAttr(65, "cursor-help d-flex"), new HTMLAttr(158, InvoiceePaymentStateModule_toString(details_1.PaymentState))], (children_24 = [react.createElement("span", {}, msg_4), questionMarkHtml], react.createElement("div", keyValueList(props_25, 1), ...children_24))), new MessageKind(1));
                    }
                    let pendingDirectInvoiceInfoMsgHtml;
                    let pattern_matching_result_5;
                    if (pendingDirectInvoiceLoadState.tag === 2) {
                        if (!isEmpty(pendingDirectInvoiceLoadState.fields[0])) {
                            pattern_matching_result_5 = 0;
                        }
                        else {
                            pattern_matching_result_5 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_5 = 1;
                    }
                    switch (pattern_matching_result_5) {
                        case 0: {
                            const iconProps = new IconProps((text = unEscape(getTranslation("Billing.DirectInvoice.InfoText")), react.createElement("div", {
                                className: "invoicee-overview__direct-invoice-info",
                            }, text)), "help");
                            pendingDirectInvoiceInfoMsgHtml = customMessage((children_30 = [(children_28 = [getTranslation("Billing.DirectInvoice.Created")], react.createElement("span", {
                                className: "mr-2",
                            }, ...children_28)), MaterialIcon_render_Z132847CC(iconProps)], react.createElement("div", {
                                className: "d-flex",
                                id: "invoicee-pending-direct-invoice",
                            }, ...children_30)), new MessageKind(0));
                            break;
                        }
                        case 1: {
                            pendingDirectInvoiceInfoMsgHtml = react.createElement(react.Fragment, {});
                            break;
                        }
                    }
                    let blockedByDebtCollectionWarningMsgHtml;
                    if (invoiceeBlockState.tag === 2) {
                        const matchValue_12 = tryHead(invoiceeBlockState.fields[0]);
                        blockedByDebtCollectionWarningMsgHtml = ((matchValue_12 != null) ? (equals(matchValue_12.BlockType, new BlockType(0)) ? ((latestInvoiceeBlock_1 = matchValue_12, react.createElement(react.Fragment, {}))) : ((latestInvoiceeBlock_2 = matchValue_12, customMessage(getTranslation((matchValue_13 = latestInvoiceeBlock_2.BlockType, (matchValue_13.tag === 2) ? "CustomerContract.Invoicee.InvoiceeBlock.Hardblock" : ((matchValue_13.tag === 0) ? "" : "CustomerContract.Invoicee.InvoiceeBlock.Softblock"))), new MessageKind(1))))) : react.createElement(react.Fragment, {}));
                    }
                    else {
                        blockedByDebtCollectionWarningMsgHtml = react.createElement(react.Fragment, {});
                    }
                    let errorMessageHtml;
                    const matchValue_14 = errorMessageState[0];
                    if (matchValue_14 == null) {
                        errorMessageHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const errorMsg = matchValue_14;
                        errorMessageHtml = error(errorMsg.split(""));
                    }
                    const children_70 = toList(delay(() => {
                        let children_53;
                        return append_1(singleton_2((children_53 = toList(delay(() => {
                            let props_52, children_51, children_43, children_41, children_39, children_49, children_45, children_47, arg_12, arg_11;
                            return append_1(singleton_2((props_52 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "flex-column", "mr-3"])))], (children_51 = [(children_43 = [(children_41 = [react.createElement("span", {
                                className: "invoicee-overview__status-container",
                            }, statusBallHtml), (children_39 = toList(delay(() => (isNullOrWhiteSpace(details_1.Name) ? singleton_2("-") : singleton_2(details_1.Name)))), react.createElement("h2", {
                                className: "invoicee-overview__name",
                            }, ...children_39))], react.createElement("div", {
                                className: "d-flex align-items-center",
                            }, ...children_41))], react.createElement("div", {
                                className: "d-flex align-items-baseline",
                            }, ...children_43)), (children_49 = [(children_45 = [toText(printf("%s: %s"))(ssnOrOrgTitle)(orgNr)], react.createElement("div", {
                                id: "identity-nr",
                                className: "invoicee-overview__identityNr",
                            }, ...children_45)), (children_47 = [(arg_12 = toString(details_1.InvoiceeNr), (arg_11 = getTranslation("CustomerContract.Invoicee.CustomerNrShort"), toText(printf("%s: %s"))(arg_11)(arg_12)))], react.createElement("div", {
                                id: "invoicee-nr",
                                className: "invoicee-overview__invoiceeNr",
                            }, ...children_47))], react.createElement("div", {
                                className: "d-flex mt-1",
                            }, ...children_49))], react.createElement("div", keyValueList(props_52, 1), ...children_51)))), delay(() => append_1(props.GlobalDependencies.ClientConfig.EnableTerminationProcess ? singleton_2(terminationProcessStateHtml) : singleton_2(paymentWarningMsgHtml), delay(() => append_1(singleton_2(blockedByDebtCollectionWarningMsgHtml), delay(() => append_1(singleton_2(pendingDirectInvoiceInfoMsgHtml), delay(() => singleton_2(errorMessageHtml)))))))));
                        })), react.createElement("div", {
                            className: "invoicee-overview__container",
                        }, ...children_53))), delay(() => {
                            let matchValue_15, subscriptionsPage, matchValue_16;
                            return append_1(singleton_2(renderHorizontalMenu(new HorizontalMenuProps(RouterModule_urlSegments(window.location.hash, 1), ofArray(["Invoicee", toString(details_1.InvoiceeNr)]), (matchValue_15 = props.CurrentPage, (matchValue_15.tag === 1) ? ((subscriptionsPage = matchValue_15.fields[1], (subscriptionsPage.tag === 9) ? (void 0) : ((subscriptionsPage.tag === 1) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 2) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 3) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 4) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 5) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 6) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 7) ? subscriptionsPage.fields[0] : ((subscriptionsPage.tag === 8) ? subscriptionsPage.fields[0] : (void 0))))))))))) : (void 0)), props.CurrentPage, details_1.InvoiceeNr, props.GlobalDependencies.ClientConfig.ShowInvoiceeFeeTab ? (new LoadState$2(2, true)) : LoadState_map((arg_13) => (!isEmpty(arg_13)), invoiceeFeesLoadState), props.GlobalDependencies.ClientNr, (matchValue_16 = props.CurrentPage, (matchValue_16.tag === 1) ? matchValue_16.fields[1] : (new Page_1(0))), props.GlobalDependencies.ClientConfig.MortgageEnabled, props.GlobalDependencies.ClientConfig.DocumentSigningEnabled, FSharpSet__Contains(props.GlobalDependencies.Privileges, "FenixWeb.Mortgage.Read"), props.GlobalDependencies.ClientConfig.AllowSendSms, props.GlobalDependencies.IsAdminUser, props.GlobalDependencies.ClientConfig.UsesNumberDirectory, () => {
                                const matchValue_17 = activePhoneNumbersState[0];
                                switch (matchValue_17.tag) {
                                    case 1:
                                    case 2: {
                                        break;
                                    }
                                    default: {
                                        loadActivePhoneNumbers(details_1.ContractNumbers);
                                    }
                                }
                                openModalState[1](new Modal(1));
                            }, () => {
                                openModalState[1](new Modal(3));
                            }, () => {
                                openModalState[1](new Modal(4));
                            }, props.GlobalDependencies.ClientConfig.EnableTerminationProcess, props.GlobalDependencies.ClientConfig.ShowInvoiceeAttributes))), delay(() => {
                                let children_68;
                                return append_1(singleton_2((children_68 = toList(delay(() => {
                                    let invoiceeDetails_4, children_58, invoiceeDetails_5, children_64, children_66, invoiceeDetails_3;
                                    const matchValue_18 = props.CurrentPage;
                                    switch (matchValue_18.tag) {
                                        case 1: {
                                            const invoiceeNr_16 = matchValue_18.fields[0];
                                            const matchValue_20 = invoiceeDetailsLoadState;
                                            return (matchValue_20.tag === 1) ? singleton_2(dotsLoading) : ((matchValue_20.tag === 3) ? singleton_2(error(matchValue_20.fields[0].split(""))) : ((matchValue_20.tag === 2) ? ((matchValue_20.fields[0] != null) ? ((invoiceeDetails_4 = matchValue_20.fields[0], singleton_2(LazyPages_SubscriptionsPage(new SubscriptionsProps(props.GlobalDependencies, matchValue_18.fields[1], invoiceeDetails_4, contractsLoadState, () => {
                                                loadContracts(invoiceeNr_16);
                                            }, () => {
                                                reduxDispatch(loadInvoiceeCurrentStateThunk(props.GlobalDependencies.ClientNr, invoiceeNr_16));
                                            }, () => {
                                                loadInvoiceeDetails(invoiceeNr_16);
                                            }))))) : singleton_2(warning(getTranslation("CustomerContract.Invoicee.InvoiceeMissing").split("")))) : singleton_2(react.createElement(react.Fragment, {}))));
                                        }
                                        case 2: {
                                            const invoiceeNr_17 = matchValue_18.fields[0];
                                            const matchValue_21 = invoiceeDetailsLoadState;
                                            let pattern_matching_result_6, details_2;
                                            if (matchValue_21.tag === 2) {
                                                if (matchValue_21.fields[0] != null) {
                                                    pattern_matching_result_6 = 0;
                                                    details_2 = matchValue_21.fields[0];
                                                }
                                                else {
                                                    pattern_matching_result_6 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_6 = 1;
                                            }
                                            switch (pattern_matching_result_6) {
                                                case 0: {
                                                    return singleton_2(renderInvoices(new InvoicesProps(props.GlobalDependencies, invoiceeNr_17, details_2.NoNextInvoice, toList(delay(() => append_1(singleton_2(details_2.Email), delay(() => ((details_2.EmailAddressInvoice != null) ? singleton_2(value_9(details_2.EmailAddressInvoice)) : empty()))))), props.GlobalDependencies.ClientConfig.IsTelecom, props.GlobalDependencies.ClientConfig.ExposeMonths, locale, props.GlobalDependencies.ClientConfig.DirectInvoice, () => loadReminderFees(props.GlobalDependencies.ClientNr, invoiceeNr_17), () => loadUpcomingInvoices(props.GlobalDependencies.ClientNr, invoiceeNr_17), () => loadPaymentOptions(props.GlobalDependencies.ClientNr), activePhoneNumbersState[0], () => {
                                                        loadActivePhoneNumbers(details_2.ContractNumbers);
                                                    }, () => loadInvoices(props.GlobalDependencies.ClientNr, invoiceeNr_17))));
                                                }
                                                case 1: {
                                                    return singleton_2(react.createElement(react.Fragment, {}));
                                                }
                                            }
                                        }
                                        case 3: {
                                            const invoiceeNr_18 = matchValue_18.fields[0];
                                            return singleton_2((children_58 = [LazyPages_NotesPage(new NotesAndDocumentsProps(props.GlobalDependencies.ClientNr, locale, invoiceeNr_18, () => loadFiles(props.GlobalDependencies.ClientNr, invoiceeNr_18), (internalFilename) => deleteFile(props.GlobalDependencies.ClientNr, invoiceeNr_18, new InvoiceeFileType(1), internalFilename), (name, blob) => uploadInvoiceeFile(props.GlobalDependencies.ClientNr, invoiceeNr_18, name, new InvoiceeFileType(1), blob)))], react.createElement("div", {
                                                className: "invoicee-notes-container",
                                            }, ...children_58)));
                                        }
                                        case 4: {
                                            const invoiceeNr_19 = matchValue_18.fields[0];
                                            const matchValue_22 = [contractsLoadState, contractTypesLoadState, invoiceeDetailsLoadState];
                                            let pattern_matching_result_7, contractTypes, contracts, details_3;
                                            if (matchValue_22[0].tag === 2) {
                                                if (matchValue_22[1].tag === 2) {
                                                    if (matchValue_22[2].tag === 2) {
                                                        if (matchValue_22[2].fields[0] != null) {
                                                            pattern_matching_result_7 = 0;
                                                            contractTypes = matchValue_22[1].fields[0];
                                                            contracts = matchValue_22[0].fields[0];
                                                            details_3 = matchValue_22[2].fields[0];
                                                        }
                                                        else {
                                                            pattern_matching_result_7 = 1;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_7 = 1;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_7 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_7 = 1;
                                            }
                                            switch (pattern_matching_result_7) {
                                                case 0: {
                                                    const thenReloadContracts = (someAsyncFn) => singleton_1.Delay(() => singleton_1.Bind(someAsyncFn, (_arg_8) => {
                                                        let res;
                                                        return singleton_1.Return((res = _arg_8, (void Result_Map((_arg_7) => {
                                                            loadContracts(invoiceeNr_19);
                                                        }, res), res)));
                                                    }));
                                                    const thenReloadInvoiceeDetails = (someAsyncFn_1) => singleton_1.Delay(() => singleton_1.Bind(someAsyncFn_1, (_arg_10) => {
                                                        let res_1;
                                                        return singleton_1.Return((res_1 = _arg_10, (void Result_Map((_arg_9) => {
                                                            loadInvoiceeDetails(invoiceeNr_19);
                                                        }, res_1), res_1)));
                                                    }));
                                                    return singleton_2(LazyPages_AgreementsPage(new AgreementsProps(props.GlobalDependencies.ClientConfig.MortgageEnabled, FSharpSet__Contains(props.GlobalDependencies.Privileges, "FenixWeb.Mortgage.EditPhysicalContract"), FSharpSet__Contains(props.GlobalDependencies.Privileges, "FenixWeb.Mortgage.Approve"), toText(printf("/Data/Mortgage/%i/%i/invoiceeFilesByInternalFilename/"))(props.GlobalDependencies.ClientNr)(invoiceeNr_19), details_3.MortgageBlocked, details_3.NoNextInvoice, props.GlobalDependencies.IsAdminUser, contracts, contractTypes, () => loadAgreements(props.GlobalDependencies.ClientNr, invoiceeNr_19), (contractNr_1) => {
                                                        let arg_16, arg_14;
                                                        return thenReloadContracts(confirmAgreementFn((arg_16 = DateTimeExtensions_toIso8601(today()), (arg_14 = getTranslation("AgreementConfirmedViaFenixBy"), toText(printf("%s %s %s"))(arg_14)(props.GlobalDependencies.CurrentUserName)(arg_16))), props.GlobalDependencies.ClientNr, invoiceeNr_19, contractNr_1));
                                                    }, (contractNr_2, comment) => thenReloadContracts(approveContract(props.GlobalDependencies.ClientNr, contractNr_2, comment)), () => thenReloadInvoiceeDetails(blockMortgage(props.GlobalDependencies.ClientNr, invoiceeNr_19)), () => thenReloadInvoiceeDetails(unblockMortgage(props.GlobalDependencies.ClientNr, invoiceeNr_19)), (internalFilename_1, contractNr_3) => thenReloadContracts(connectAgreement(props.GlobalDependencies.ClientNr, invoiceeNr_19, internalFilename_1, contractNr_3)), (internalFilename_2, contractNr_4) => thenReloadContracts(deleteConnection(props.GlobalDependencies.ClientNr, invoiceeNr_19, contractNr_4, internalFilename_2)), (name_1, blob_1) => thenReloadContracts(uploadInvoiceeFile(props.GlobalDependencies.ClientNr, invoiceeNr_19, name_1, new InvoiceeFileType(0), blob_1)), (internalFilename_3) => deleteAgreement(props.GlobalDependencies.ClientNr, invoiceeNr_19, internalFilename_3), () => loadAllContractTypes(props.GlobalDependencies.ClientNr))));
                                                }
                                                case 1: {
                                                    return singleton_2(react.createElement(react.Fragment, {}));
                                                }
                                            }
                                        }
                                        case 5: {
                                            return singleton_2(LazyPages_CustomerFeesPage(new CustomerFeesProps(matchValue_18.fields[0], props.GlobalDependencies, details_1.PaymentMethod, locale)));
                                        }
                                        case 6: {
                                            return singleton_2(LazyPages_HistoryPage(new InvoiceeHistoryProps(props.GlobalDependencies, matchValue_18.fields[0], locale)));
                                        }
                                        case 7: {
                                            return props.GlobalDependencies.IsAdminUser ? singleton_2(renderWholesaleRGU(new WholesaleRGUProps(props.GlobalDependencies.ClientNr, matchValue_18.fields[0], locale))) : singleton_2(react.createElement(react.Fragment, {}));
                                        }
                                        case 8: {
                                            if (props.GlobalDependencies.ClientConfig.IsTelecom) {
                                                const matchValue_25 = invoiceeDetailsLoadState;
                                                return (matchValue_25.tag === 1) ? singleton_2(dotsLoading) : ((matchValue_25.tag === 3) ? singleton_2(error(matchValue_25.fields[0].split(""))) : ((matchValue_25.tag === 2) ? ((matchValue_25.fields[0] != null) ? ((invoiceeDetails_5 = matchValue_25.fields[0], singleton_2(render_2(new NumberDirectoryProps(locale, invoiceeDetails_5, props.GlobalDependencies))))) : singleton_2(warning(getTranslation("CustomerContract.Invoicee.InvoiceeMissing").split("")))) : singleton_2(react.createElement(react.Fragment, {}))));
                                            }
                                            else {
                                                return singleton_2(react.createElement(react.Fragment, {}));
                                            }
                                        }
                                        case 9: {
                                            return singleton_2(LazyPages_AttributesPage(new AttributesProps(props.GlobalDependencies.ClientNr, matchValue_18.fields[0], locale)));
                                        }
                                        case 10: {
                                            return singleton_2((children_64 = [warning(getTranslation("CustomerContract.Invoicee.MissingInvoiceeNr").split(""))], react.createElement("div", {}, ...children_64)));
                                        }
                                        case 11: {
                                            return singleton_2((children_66 = [warning("404 - Not Found".split(""))], react.createElement("div", {}, ...children_66)));
                                        }
                                        default: {
                                            const matchValue_19 = invoiceeDetailsLoadState;
                                            return (matchValue_19.tag === 1) ? singleton_2(dotsLoading) : ((matchValue_19.tag === 3) ? singleton_2(error(matchValue_19.fields[0].split(""))) : ((matchValue_19.tag === 2) ? ((matchValue_19.fields[0] != null) ? ((invoiceeDetails_3 = matchValue_19.fields[0], singleton_2(LazyPages_DetailsPage(new InvoiceeDetailsProps(props.GlobalDependencies, invoiceeDetails_3, () => {
                                                loadInvoiceeDetails(matchValue_18.fields[0]);
                                            }))))) : singleton_2(warning(getTranslation("CustomerContract.Invoicee.InvoiceeMissing").split("")))) : singleton_2(react.createElement(react.Fragment, {}))));
                                        }
                                    }
                                })), react.createElement("div", {}, ...children_68))), delay(() => append_1(singleton_2(sendSMSModalHtml), delay(() => append_1(props.GlobalDependencies.ClientConfig.EnableTerminationProcess ? singleton_2(pauseTerminationProcessModalHtml) : empty(), delay(() => singleton_2(deleteInvoiceeModalHtml)))))));
                            }));
                        }));
                    }));
                    return react.createElement("section", {
                        className: "invoicee-overview",
                    }, ...children_70);
                }
                else {
                    const children_8 = [warning(getTranslation("CustomerContract.Invoicee.InvoiceeMissing").split(""))];
                    return react.createElement("div", {}, ...children_8);
                }
            }
            else {
                return dotsLoading;
            }
        }
    }
}, "Invoicee", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoicee\\View.fs", 1238);

